import React from 'react';
import Lightbox from 'react-images';

import './ProcedureGallery.scss';

import allImages from '../../../assets/img/llc/surgery/procedures';
import specialImages from '../../../assets/img/llc/special';

class ProcedureGallery extends React.Component {

    constructor() {
        super();
        this.state = {
            lightboxIsOpen: false,
            currentImage: 0
        }
    }

    gotoPrevious = () => {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    };

    openLightbox = (event) => {
        event.preventDefault();
        this.setState({
            currentImage: parseInt(event.currentTarget.id),
            lightboxIsOpen: true,
        });
    };

    gotoNext = () => {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    };

    closeLightbox = () => {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    };

    imagesObjects = () => {
        let returnObject = {
            images: {},
            imagesTn: {},
            error: true
        };

        const {surgery, procedure} = this.props.params;
        if (!allImages[surgery].full) return returnObject;
        returnObject.images = allImages[surgery].full[procedure];
        returnObject.imagesTn = allImages[surgery].tn[procedure];
        if (!returnObject.images) return returnObject;

        returnObject.error = false;
        return returnObject;
    };

    renderLightBox = () => {
        const {images, error} = this.imagesObjects();
        if (error) return <span/>;

        let imagesArray = [];

        Object.keys(images)
          .sort((key1, key2) => (parseInt(key1.substr(1)) > parseInt(key2.substr(1))) ? 1 : -1)
          .forEach((key, index) => {
            const img = images[key];

            imagesArray.push({src: img.before, caption: "PŘED"});
            imagesArray.push({src: img.after, caption: "PO"});
        });

        return (
            <Lightbox
                currentImage={this.state.currentImage}
                images={imagesArray ? imagesArray : []}
                isOpen={this.state.lightboxIsOpen}
                onClickPrev={this.gotoPrevious}
                onClickNext={this.gotoNext}
                onClose={this.closeLightbox}
            />
        )
    };

    isImages = () => {
        const {surgery, procedure} = this.props.params;
        if (!allImages[surgery].full) return false;
        return allImages[surgery].full[procedure];
    };

    renderSpecialLightBox = () => {
        const {surgery, procedure} = this.props.params;
        if (procedure === "laserove-beleni-zubu") {
            let returnObject = {
                images: specialImages["laserove-beleni-zubu"],
                error: false
            };

            let imagesArray = [];

            Object.keys(returnObject.images).forEach((key, index) => {
                const img = returnObject.images[key];

                imagesArray.push({src: img});
            });

            return (
                <Lightbox
                    currentImage={this.state.currentImage}
                    images={imagesArray ? imagesArray : []}
                    isOpen={this.state.lightboxIsOpen}
                    onClickPrev={this.gotoPrevious}
                    onClickNext={this.gotoNext}
                    onClose={this.closeLightbox}
                />
            )
        }
        else return <span/>
    };

    renderSpecialContent = () => {
        const {surgery, procedure} = this.props.params;
        if (procedure === "laserove-beleni-zubu") {
            return specialImages["laserove-beleni-zubu"].map((img, index) => {
                return <div className="col-3 procedureGallery_item_col special" key={index}>
                    <div className="procedureGallery_item_wrap clearfix">
                        <div className="procedureGallery_item"
                             id={index}
                             onClick={this.openLightbox.bind(this)}>
                            <div className="procedureGallery_item_img"><img src={img}/></div>
                        </div>
                    </div>
                </div>
            });
        }
        else return <span/>
    };

    renderImages = () => {
        const {images, imagesTn, error} = this.imagesObjects();
        if (error) return <span/>;

        let imgIndex = 0;

        return Object.keys(images)
          .sort((key1, key2) => (parseInt(key1.substr(1)) > parseInt(key2.substr(1))) ? 1 : -1)
          .map((key, index) => {
            const bundle = (imagesTn && imagesTn[key]) ? imagesTn[key] : images[key];
            return (
                <div className="col-6 procedureGallery_item_col" key={index}>
                    <div className="procedureGallery_item_wrap clearfix">
                        <div className="procedureGallery_item"
                             id={imgIndex++}
                             onClick={this.openLightbox.bind(this)}>
                            <div className="procedureGallery_item_img">
                                <div className="procedureGallery_item_img"><img src={bundle.before}/></div>
                            </div>
                        </div>
                        <div className="procedureGallery_item"
                             id={imgIndex++}
                             onClick={this.openLightbox.bind(this)}>
                            <div className="procedureGallery_item_img"><img src={bundle.after}/></div>
                        </div>
                    </div>
                </div>
            )
        })
    };

    render() {
        return (
            <section className="procedureGallery">
                <div className="container">
                    {this.isImages() &&
                    <div className="procedureGallery_item_row row">
                        <div className="col-6 procedureGallery_item_col">
                            <div className="procedureGallery_item_wrap clearfix">
                                <div className="procedureGallery_item">
                                    <div className="procedureGallery_item_title">Před Zákrokem</div>
                                </div>
                                <div className="procedureGallery_item">
                                    <div className="procedureGallery_item_title">Po Zákroku</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 procedureGallery_item_col hidden-xs">
                            <div className="procedureGallery_item_wrap clearfix">
                                <div className="procedureGallery_item">
                                    <div className="procedureGallery_item_title">Před Zákrokem</div>
                                </div>
                                <div className="procedureGallery_item">
                                    <div className="procedureGallery_item_title">Po Zákroku</div>
                                </div>
                            </div>
                        </div>


                        {this.renderImages()}

                        {this.renderLightBox()}
                    </div>
                    }

                    <div className="procedureGallery_item_row row">
                        {this.renderSpecialContent()}
                        {this.renderSpecialLightBox()}
                    </div>

                </div>
            </section>
        );
    }
}

export default ProcedureGallery;


// WEBPACK FOOTER //
// ./src/components/Procedure/ProcedureGallery/ProcedureGallery.js